import { render, staticRenderFns } from "./IOs.vue?vue&type=template&id=c479de3e&scoped=true"
import script from "./IOs.vue?vue&type=script&lang=js"
export * from "./IOs.vue?vue&type=script&lang=js"
import style0 from "./IOs.vue?vue&type=style&index=0&id=c479de3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c479de3e",
  null
  
)

export default component.exports